import { __decorate } from "tslib";
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, PreloadAllModules } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
/*
 * Platform and Environment providers/directives/pipes
 */
import { environment } from '../environments/environment';
/**
 * Enterprise shop shared modules
 */
import { SharedModule } from './shared';
/**
 * Enterprise shop modules
 */
import { ROUTES } from './app.routes';
import '../styles/styles.scss';
import '../styles/headings.css';
// App is our top level component
import { AppComponent } from './app.component';
import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { AppState } from './app.service';
// Modules
import { BasketOverviewModule } from './modules/basket-overview';
import { CheckoutIntroModule } from './modules/checkout-intro';
import { CheckoutFormModule } from './modules/checkout-form';
import { TotalCostsModule } from './modules/total-costs';
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        // tslint:disable-next-line
        return this.indexOf(searchString, position) === position;
    };
}
// Application wide providers
var APP_PROVIDERS = APP_RESOLVER_PROVIDERS.concat([
    AppState
]);
/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
var AppModule = /*@__PURE__*/ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/app.module.ts
// module id = null
// module chunks = 